import lozad from 'lozad';
import landingPageEngine from '@js/utilities/landingPageEngine';

landingPageEngine.debug();

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

const galleryChangeButtons = [...document.querySelectorAll(`.js-change-landing-gallery`)];

const galleryItems = [...document.querySelectorAll(`.js-landing-gallery-item`)];

const getSrc = ({ landing, color, position }) =>
    `/img/landings-galleries/${landing}/${position}-${color}.webp`;

const promises = [];

function changeGallery(landing, color) {
    galleryItems.forEach((el, index) => {
        // el.srcset = getSrcSet({ landing, color, position: index + 1 });
        el.src = getSrc({ landing, color, position: index + 1 });
        promises.push(el);
    });

    return true;
}

galleryChangeButtons.forEach((el) =>
    el.addEventListener('click', () => {
        const currentActive = galleryChangeButtons.find((ell) =>
            ell.classList.contains('is-active')
        );

        currentActive?.classList.remove('is-active');
        el.classList.add('is-active');

        changeGallery(el.getAttribute('data-landing'), el.getAttribute('data-color'));
    })
);

galleryChangeButtons[0]?.click();

const stoneButtons = [...document.getElementsByClassName(`js-stone-btn`)];
const stoneButtonsArray = Array.from(stoneButtons);

const stoneVideo = document.getElementById('js-stone-video');

stoneButtonsArray.forEach((el) =>
    el.addEventListener('click', async () => {
        const video = el.getAttribute('data-video');

        // stoneVideo.src = video;
        stoneVideo.hlsInstance.loadSource(video);

        const currentlyActive = stoneButtons.find((ell) => ell.classList.contains('is-active'));
        currentlyActive?.classList.remove('is-active');
        el.classList.add('is-active');
    })
);

/* eslint-enable */

// const landingScrollableSectionListener = () => {
//     const landingScrollableSectionElements = document.querySelectorAll(
//         '.landing-scrollable-section'
//     );

//     // console.log({ landingScrollableSectionElements });

//     landingScrollableSectionElements.forEach((el) => {
//         const container = el.closest('.landing-sticky');

//         // console.log({ container });

//         container.addEventListener('position-change', (e) => {
//             // console.log('position-change', {
//             //     position: e.detail.position,
//             //     containerHeight: container.offsetHeight,
//             //     containerScrollTop: container.scrollTop,
//             //     scroll: container.offsetHeight * e.detail.position,
//             //     scrollChild: el.offsetHeight * e.detail.position,
//             // });
//             el.scrollTo({
//                 top: el.offsetHeight * e.detail.position,
//             });
//         });
//     });
// };

// landingScrollableSectionListener();
